const Movement = {
    getPendingList: () => "store/movement/pending",
    getAvailableBarcodes: () => "store/movement/available-barcodes",
    markAsDelivered: () => "store/movement/deliver",
    processProcurement: () => "store/movement/processed",
    deliveredProcurement: () => "store/movement/delivered",
    getCancelledProcurement: () => "store/movement/cancelled",
    getMovementStoreList: (id: string) => `store/movement/${id}/stores`,
    assignStore:()=> `store/movement/assign-store`,
    cancelledProcurement:(id:string)=> `store/movement/${id}/cancel`
  }
  

export default Movement